var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small game-online",class:[_vm.state === 'live' ? _vm.dataSport.textClass : 'text-white-50 state-small']},[_vm._v(_vm._s(_vm.state))])}
var staticRenderFns = []

export { render, staticRenderFns }